export const STORE_CHART = 'CHART/STORE_CHART';
